import { MailCheck, Fingerprint, HardDrive, Smartphone, Server, ShieldAlert } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import byodHeroBg from "@/assets/byod-hero-bg.jpg";
import passkeysHeroBg from "@/assets/passkeys-hero-bg.jpg";
import managedHeroBg from "@/assets/managed-hero-bg.jpg";
import sharePointHeroBg from "@/assets/sharepoint-hero-bg.jpg";
import riskySigninsHeroBg from "@/assets/risky-signins-hero-bg.jpg";
import veiligMailenZorgHeroBg from "@/assets/veilig-mailen-zorg-hero-bg.jpg";

export interface Praktijkvoorbeeld {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  icon: LucideIcon;
  heroImage: string;
  category: "algemeen" | "zorg";
}

export const praktijkvoorbeelden: Praktijkvoorbeeld[] = [
  {
    slug: "byod",
    title: "BYOD beveiliging",
    subtitle: "Privétoestellen, zakelijke data",
    description:
      "Je medewerkers gebruiken hun eigen telefoon voor werk. Maar hoe bescherm je bedrijfsdata zonder hun privacy aan te tasten?",
    icon: Smartphone,
    heroImage: byodHeroBg,
    category: "algemeen",
  },
  {
    slug: "passkeys",
    title: "Passkeys",
    subtitle: "Wachtwoordloos inloggen",
    description:
      "Wachtwoorden zijn de zwakste schakel in je beveiliging. Ontdek hoe passkeys je bedrijf beschermen tegen phishing en hacks.",
    icon: Fingerprint,
    heroImage: passkeysHeroBg,
    category: "algemeen",
  },
  {
    slug: "onedrive",
    title: "Lokaal vs. OneDrive",
    subtitle: "Slim opslaan in de cloud",
    description:
      "Waarom het uitmaakt wáár je bestanden bewaart — en hoe OneDrive je organisatie beschermt tegen dataverlies.",
    icon: HardDrive,
    heroImage: managedHeroBg,
    category: "algemeen",
  },
  {
    slug: "sharepoint",
    title: "SharePoint vs. NAS",
    subtitle: "Van lokale server naar de cloud",
    description:
      "Waarom moderne organisaties overstappen van NAS en lokale servers naar SharePoint — en hoe Teams het toegangsbeheer simpel maakt.",
    icon: Server,
    heroImage: sharePointHeroBg,
    category: "algemeen",
  },
  {
    slug: "risicovolle-aanmeldingen",
    title: "Risicovolle aanmeldingen",
    subtitle: "Verdachte inlogpogingen herkennen",
    description:
      "Elke dag worden er duizenden inlogpogingen gedaan. De meeste zijn legit. Maar wat als iemand inlogt vanuit São Paulo — terwijl hij in Utrecht zit?",
    icon: ShieldAlert,
    heroImage: riskySigninsHeroBg,
    category: "algemeen",
  },
  {
    slug: "veilig-mailen-zorg",
    title: "Veilig mailen in de zorg",
    subtitle: "Eén adres voor gewone én veilige mail",
    description:
      "Twee mailadressen, twee mailboxen en steeds kiezen: veilig of gewoon? Zo mail je veilig met patiënten en zorgverleners vanuit je eigen Outlook.",
    icon: MailCheck,
    heroImage: veiligMailenZorgHeroBg,
    category: "zorg",
  },
];
